import React from 'react';
import { CheckIcon } from 'lucide-react';
import { WhatsAppButton } from './WhatsAppButton';
import { SHOPIFY_MESSAGE } from '../utils/contact';
const bullets = ['Ideal para productos digitales y físicos', 'Conexión con Shopify', 'Botones de compra claros', 'Copy persuasivo', 'Diseño mobile-first', 'Enlace a Instagram, Facebook y WhatsApp'];
export function ShopifySpotlight() {
  return <section className="relative py-20 lg:py-28" data-id="element-237" data-mp="e2vzjpai8mdz">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-1/2 h-64 w-[80%] -translate-x-1/2 -translate-y-1/2 rounded-full bg-neon/8 blur-[130px]" data-id="element-238" data-mp="e1kw5qkz1gne" />
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-239" data-mp="nvl5y5r77a2g">
        <div className="relative rounded-3xl border border-neon/50 bg-ink-900 p-8 shadow-glow lg:p-14" data-id="element-240" data-mp="j1qqxfmjfj9p">
          <div className="grid gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:gap-16" data-id="element-241" data-mp="3rhjwx0j8tcci">
            <div data-id="element-242" data-mp="3mk0erpjfcffa">
              <div aria-hidden="true" className="h-px w-16 bg-neon/70" data-id="element-243" data-mp="3mifjtyt76ugw" />
              <h2 className="mt-6 text-3xl font-semibold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-244" data-mp="1ldxp2da5wrco">
                De una simple tienda a una experiencia de venta
              </h2>
              <p className="mt-5 max-w-xl text-base leading-relaxed text-mist-muted" data-id="element-245" data-mp="1u5zpibk8e7my">
                Una tienda online por sí sola no siempre vende. En YenniDigital creamos páginas de
                venta estratégicas que presentan tu producto, explican sus beneficios, generan
                confianza y conectan al cliente con tu tienda Shopify para completar la compra.
              </p>
              <WhatsAppButton message={SHOPIFY_MESSAGE} size="lg" className="mt-9" data-id="element-246" data-mp="1bfhycbf1rk3p">
                Quiero vender online
              </WhatsAppButton>
            </div>

            <ul className="grid gap-3 self-center sm:grid-cols-2 lg:grid-cols-1" data-id="element-247" data-mp="1gc8bapvk1zkw">
              {bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-248" data-mp="2rt837kdzqcee">
                  <span className="mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full bg-neon/15 text-neon" data-id="element-249" data-mp="2rvkuio5n1z44">
                    <CheckIcon className="h-3 w-3" aria-hidden="true" data-id="element-250" data-mp="1x69lvrpxgtga" />
                  </span>
                  <span className="text-sm leading-relaxed text-mist" data-id="element-251" data-mp="1x8m322nv2zsa">{bullet}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}